import { Box, Typography } from "@mui/material";
import { capitalizeFirstLetter } from "../../../../../posture/controls/components/EntitiesSection/utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const GitHubSecretDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.github_secret_data?.name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Secret Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.github_secret_data?.name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.github_secret_data?.organization && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Organization</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.github_secret_data?.organization}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.github_secret_data?.type && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Secret Type</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                "GitHub " +
                capitalizeFirstLetter(entityData?.github_secret_data?.type)
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.github_secret_data?.scope && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Secret Scope</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={capitalizeFirstLetter(
                entityData?.github_secret_data?.scope
              )}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.github_secret_data?.visibility && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Visibility</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={capitalizeFirstLetter(
                entityData?.github_secret_data?.visibility
              )}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.github_secret_data?.selected_repositories &&
        entityData?.github_secret_data?.selected_repositories.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Repositories</Typography>
            </Box>
            <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
              {entityData?.github_secret_data?.selected_repositories.map(
                (alias, index) => (
                  <TextIntegrationStyle key={index} title={""} value={alias} />
                )
              )}
            </Box>
          </Box>
        )}
      {entityData?.github_secret_data?.repository && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Repository</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.github_secret_data?.repository}
            />
          </Box>
        </Box>
      )}
      {entityData?.github_secret_data?.environment && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Secret Environment</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.github_secret_data?.environment}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default GitHubSecretDetailsView;
